<template>
  <div class="hm-date-select">
    <!-- <div>
      <el-radio-group
        v-model="runningTimeType"
        @change="swithRunningTimeType"
        size="small"
      >
        <el-radio label="all">全时段</el-radio>
        <el-radio label="special">特定时段</el-radio>
      </el-radio-group>
    </div> -->
    <div class="deadline hm-form-container">
      <div>
        <div class="flex item-center mb10">
          <span class="icon" style="margin-right:4px">* </span>
          <div style="color: #606266;font-weight: 700;">{{ title }}日期：</div>
          <el-date-picker
            v-model="ruleDate"
            type="daterange"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
            :disabled="!disableDate || disableEditDate"
          >
          </el-date-picker>
        </div>
        <div class="margin-bottom flex item-center">
          <el-radio-group
            v-model="dateType"
            class="margin-right"
            @change="swithRunningTimeType"
            size="small"
            :disabled="disableEditDate"
          >
            <el-radio-button label="day">日</el-radio-button>
            <el-radio-button label="week">周</el-radio-button>
            <el-radio-button label="month">月</el-radio-button>
          </el-radio-group>
          <div style="flex: 1">
            <div v-if="dateType === 'day'">
              每：
              <el-input
                size="small"
                :disabled="disableEditDate"
                @mousewheel.prevent.native
                clearable
                type="number"
                style="width: 80px"
                v-model.trim="dateValue"
              ></el-input>
              <span class="unit">天</span>
            </div>
            <div v-if="dateType === 'week'" class="flex">
              每周：
              <el-checkbox-group
                :disabled="disableEditDate"
                v-model="week"
                class="flex"
              >
                <el-checkbox
                  v-for="(v, i) in weekList"
                  :key="i"
                  :label="v.value"
                  >{{ v.day }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
            <div v-if="dateType === 'month'" class="flex">
              每：
              <el-checkbox-group
                v-model="daysList"
                :disabled="disableEditDate"
                class="flex flex-wrap month-check-box-wrapper"
              >
                <el-checkbox
                  v-for="(v, i) in monthList"
                  :key="i"
                  :label="v.day"
                  >{{ v.day }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </div>
        </div>
        <div class="flex item-center" v-if="isShow">
          <span>{{ title }}时间：</span>
          <div>
            <div class="item flex item-center">
              <div class="flex">
                <el-time-picker
                  :disabled="disableEditDate"
                  size="small"
                  is-range
                  v-model="selectedTime"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  placeholder="选择时间范围"
                >
                </el-time-picker>
                <div class="add-wrapper" v-if="!disableEditDate">
                  <span
                    class="hmicon icon-hao pointer"
                    @click="addtionTime()"
                    v-show="selectedTime && selectedTime.length > 0"
                  ></span>
                </div>
              </div>
              <div></div>
            </div>
          </div>
        </div>
        <div class="flex item-center" v-if="isShow">
          <span>已选时间：</span>
          <div class="time-list">
            <div
              v-for="(item, i) in dateConfigRange"
              :key="i"
              class="time-list-item"
            >
              <div class="time flex flex-between">
                <div class="time-wrapper">
                  <span>{{ item.promotionStartTime }}</span>
                  <span class="margin">至</span>
                  <span>{{ item.promotionEndTime }}</span>
                </div>
                <div class="minus-wrapper" v-if="!disableEditDate">
                  <span
                    class="hmicon icon-jianhao pointer"
                    @click="deleteTime(i)"
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div v-show="runningTimeType === 'all'">
        <el-date-picker
          v-if="datePicker"
          v-model="ruleDateAndTime"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :default-time="['00:00:00', '23:59:59']"
          size="small"
        >
        </el-date-picker>
        <el-date-picker
          v-else
          v-model="ruleDateAndTime"
          :picker-options="pickerOptions"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :default-time="['00:00:00', '23:59:59']"
          size="small"
        >
        </el-date-picker>
      </div> -->
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  props: {
    title: { type: String },
    isShow: { type: Boolean },
    datePicker: { type: Boolean },
    disableDate: {
      type: Boolean,
      defalt: false
    },
    disableEditDate: {
      type: Boolean,
      defalt: false
    },
    applydate: {
      type: Array,
      defalt: () => []
    }
  },
  data() {
    const month = [];
    for (let i = 1; i < 32; i++) {
      month.push({ day: i < 10 ? "0" + i : i, value: String(i) });
    }
    return {
      pickerOptions: {
        disabledDate: time => {
          if (this.disableDate) {
            const endDate = new Date(this.applydate[1]).getTime();
            const startDate = new Date(this.applydate[0]).getTime();

            return time.getTime() < startDate || time.getTime() > endDate;
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        }
      },
      runningTimeType: "special",
      ruleDate: [],
      selectedWeek: [],
      selectedMonth: [],
      dateValue: 1,
      week: [],
      daysList: [],
      tip: "",
      isRequiredFormat: true,
      selectedTime: [
        new Date(2016, 9, 10, 0, 0, 0),
        new Date(2016, 9, 10, 23, 59, 59)
      ],
      ruleDateAndTime: [],
      dateType: "day",
      dateConfigRange: [
        { promotionStartTime: "00:00:00", promotionEndTime: "23:59:59" }
      ],
      weekList: [
        {
          day: "一",
          value: "1"
        },
        {
          day: "二",
          value: "2"
        },
        {
          day: "三",
          value: "3"
        },
        {
          day: "四",
          value: "4"
        },
        {
          day: "五",
          value: "5"
        },
        {
          day: "六",
          value: "6"
        },
        {
          day: "日",
          value: "7"
        }
      ],
      monthList: month
    };
  },
  watch: {
    runningTimeType(val) {
      if (val === "all") {
        this.week = [];
        this.daysList = [];
        this.dateValue = 1;
        this.daysList = [];
        this.week = [];
        this.ruleDate = [];
      } else if (val === "special") {
        this.ruleDateAndTime = [];
      }
    },
    dateType(val) {
      if (val === "day") {
        this.week = [];
        this.daysList = [];
        this.day = 1;
      } else if (val === "week") {
        this.day = "";
        this.daysList = [];
      } else if (val === "month") {
        this.day = "";
        this.week = [];
      }
    }
  },
  methods: {
    swithRunningTimeType() {
      this.$emit("swithRunningTimeType");
    },
    addtionTime() {
      // 开始时间小于结束时间
      const promotionStartTime = moment(this.selectedTime[0]).format(
        "HH:mm:ss"
      );
      const promotionEndTime = moment(this.selectedTime[1]).format("HH:mm:ss");
      const currentTimeListLen = this.dateConfigRange
        ? this.dateConfigRange.length
        : 0;
      const currentTimeList = this.dateConfigRange || [];
      if (promotionStartTime < promotionEndTime) {
        if (currentTimeListLen) {
          // 当前时间段的结束时间应小于已选时间段的开始时间或
          // 当前时间段的开始时间大于已选时间段的结束时间
          // 当前时间段的等于已选时间段
          const isCommon = currentTimeList.filter(v => {
            return (
              (promotionStartTime > v.promotionStartTime &&
                promotionStartTime < v.promotionEndTime) ||
              (promotionEndTime > v.promotionStartTime &&
                promotionEndTime < v.promotionEndTime) ||
              (promotionStartTime === v.promotionStartTime &&
                promotionEndTime === v.promotionEndTime) ||
              (promotionStartTime <= v.promotionStartTime &&
                promotionEndTime >= v.promotionEndTime)
            );
          }).length;
          if (isCommon) {
            this.$message.error("添加时间应大于或小于已选时间段");
          } else {
            this.dateConfigRange.push({ promotionStartTime, promotionEndTime });
          }
        } else {
          this.dateConfigRange.push({ promotionStartTime, promotionEndTime });
        }
      } else {
        this.$message.error("开始时间应小于结束时间");
      }
    },
    deleteTime(i) {
      this.dateConfigRange.splice(i, 1);
    }
  }
};
</script>
<style lang="scss" scoped>
.title {
  font-size: 14px;
  padding: 0.5rem 0;
  .star {
    color: #f56c6c;
  }
}
.month-check-box-wrapper {
  width: 30%;
}
.deadline {
  margin-top: 0.5rem;
  input[type="number"] {
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 36px;
    line-height: 36px;
    outline: 0;
    padding: 0 15px;
    -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 150px;
    text-align: left;
  }
  input[type="number"]:focus {
    border-color: #409eff;
    outline: 0;
  }
}
.time-wrapper {
  flex: 1;
  text-align: center;
  padding-right: 10px;
  font-size: 14px;
}
.time {
  height: 32px;
  line-height: 32px;
  align-items: center;
}
.margin {
  margin: 0 2.5rem 0 2.5rem;
}

.margin-bottom {
  margin-bottom: 10px;
}
.margin-right {
  margin-right: 10px;
}
.icon {
  color: #e4393c;
}

.unit {
  margin-left: 0.5rem;
}

.error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
}

.time-tip {
  margin-left: 10px;
  font-size: 0.8rem;
  color: #666;
}

.hm-date-select {
  font-size: 14px;
}

.time-list {
  width: 397px;
}

.time-list-item:not(:last-child) {
  margin-bottom: 10px;
}

.add-wrapper {
  width: 30px;
  height: 30px;
  line-height: 30px;
  background: #e50065;
  color: #fff;
  text-align: center;
  border-radius: 50%;
  margin-left: 10px;
  .hmicon {
    font-size: 14px;
  }
}

.minus-wrapper {
  width: 30px;
  height: 30px;
  line-height: 30px;
  color: #fff;
  text-align: center;
  border-radius: 50%;
  border: 1px solid #e50065;
  margin-left: 10px;
  box-sizing: border-box;
  .hmicon {
    color: #e50065;
    font-size: 14px;
  }
}
</style>
